"use strict";
$(document).ready(() => {
    let twitterIcons = [];
    const twitterIconsIntroPara = document.querySelectorAll('.intro-para .icon-tw');
    const twitterIconsEventAgenda = document.querySelectorAll('.section-events-listing .event-section .social-nav .icon-tw');
    const twitterIconsArticleContent = document.querySelectorAll('.article-main-content .icon-tw');
    if (twitterIconsIntroPara && twitterIconsIntroPara.length > 0) {
        twitterIcons = [
            ...twitterIcons,
            ...twitterIconsIntroPara,
        ];
    }
    if (twitterIconsEventAgenda && twitterIconsEventAgenda.length > 0) {
        twitterIcons = [
            ...twitterIcons,
            ...twitterIconsEventAgenda,
        ];
    }
    if (twitterIconsArticleContent && twitterIconsArticleContent.length > 0) {
        twitterIcons = [
            ...twitterIcons,
            ...twitterIconsArticleContent,
        ];
    }
    twitterIcons.forEach(iconItem => {
        const anchorElement = iconItem.parentNode;
        const shareUrl = window.location.href;
        // console.log(shareUrl);
        const encodedLink = encodeURI(shareUrl);
        // console.log(encodedLink);
        const twitterShareUrl = `https://x.com/intent/tweet?url=${encodedLink}`;
        anchorElement.href = twitterShareUrl;
        // anchorElement.addEventListener('click', (e) => {
        //     e.preventDefault();
        //     // const currentHref = anchorElement.href;
        //     // console.log(currentHref);
        //     // const urlParams = new URL(currentHref).searchParams;
        //     // const shareUrl = urlParams.get('url');
        //
        //     window.open(fbShareUrl, '_blank');
        // })
    });
});
